/*
 * @Description: 报价单有关语言包
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  新增报价单: '新增报价单',
  列设置: '列设置',
  查看: '查看',
  复制: '复制',
  复制报价单: '复制报价单',
  基本信息: '基本信息',
  系统信息: '系统信息',
  报价明细: '报价明细',
  添加明细: '添加明细',
  合计: '合计',
  含税: '含税',
  客户折后总价: '客户折后总价',
  数据加载中: '数据加载中',
  编辑报价单明细: '编辑报价单明细',
  添加报价单明细: '添加报价单明细',
  数据保存中: '数据保存中',
  操作失败: '操作失败',
  是必填项: '是必填项',
  是必选项: '是必选项',
  暂无此报价单查看权限: '暂无此报价单查看权限',
  加载中: '加载中',
  详细信息: '详细信息',
  全选: '全选',
  审批记录: '审批记录',
  历史报价: '历史报价',
  报价单: '报价单',
  客户: '客户',
  商机名称: '商机名称',
  报价单金额: '报价单金额',
  报价日期: '报价日期',
  暂无历史报价记录: '暂无历史报价记录',
  选择价格: '选择价格',
  请选择产品名称: '请选择产品名称',
  获取数据失败: '获取数据失败'
};
